import { makeGoalCalculator } from "./makeGoalCalculator";

export default makeGoalCalculator({
  key: "dream-car",
  title: "Dream Car",
  description: "Plan the down payment for your dream car — finance part with a loan, save for the rest.",
  loan: true,
  labels: {
    presentCost: "Current cost of dream car",
    years: "Years until you drive your dream car",
    currentSavings: "Current savings for dream car",
    loan: "Funded by car loan",
  },
  defaults: { presentCost: 15_00_000, yearsToGoal: 4, loanPct: 70 },
});
